import { cva } from '@/styled-system/css';

export const popoverHeaderRecipe = cva({
  base: {
    'display': 'flex',
    'alignItems': 'center',
    'gap': 'Popover.Header.gap.leading',
    'flexGrow': 0,
    'flexShrink': 0,
    'flexBasis': 'auto',
    'paddingBlock': 'Popover.Header.padding.vert',
    'paddingInlineStart': 'Popover.Header.padding.left',
    'paddingInlineEnd': 'Popover.Header.padding.right',
    'borderStartStartRadius': 'Popover.Content',
    'borderStartEndRadius': 'Popover.Content',
    'backgroundColor': 'Popover.Header.bg.default',

    '& > [data-c11n-component="Heading"]': {
      color: 'Popover.Header.text',
      textStyle: 'body-bold',
    },

    '& [data-c11n-component="ToneIcon"]': {
      width: 'Popover.Header.icon.width',
      height: 'Popover.Header.icon.height',
    },
  },
  variants: {
    tone: {
      neutral: {},
      critical: {
        'backgroundColor': 'Popover.Header.bg.critical',
        '& [data-c11n-component="ToneIcon"]': {
          color: 'Popover.Header.icon.critical',
        },
      },
      info: {
        'backgroundColor': 'Popover.Header.bg.info',
        '& [data-c11n-component="ToneIcon"]': {
          color: 'Popover.Header.icon.info',
        },
      },
      success: {
        'backgroundColor': 'Popover.Header.bg.success',
        '& [data-c11n-component="ToneIcon"]': {
          color: 'Popover.Header.icon.success',
        },
      },
      warning: {
        'backgroundColor': 'Popover.Header.bg.warning',
        '& [data-c11n-component="ToneIcon"]': {
          color: 'Popover.Header.icon.warning',
        },
      },
    },
  },
});
